<template>
	<span>
		<v-container fluid fill-height class="download-hero" style="max-height: 50vh;">
			<v-row align-center justify-center fill-height>
				<v-col class="font-weight-white text-center white--text headline">
					<h1 >پشتیبانی سریع و ارزان</h1>
				</v-col>
			</v-row>
		</v-container>
	</span>
</template>

<script>
	export default {
		name: "DownloadHero",
	};
</script>

<style scoped>
	.download-hero {
		background: url("~@/assets/img/download-hero.jpg");
		background-size: cover;
		width: 100%;
		height: 50%;
	}
	.fade-enter,
	.fade-appear {
		opacity: 1;
	}
	.fade-enter-to,
	.fade.appear-to {
		opacity: 0;
	}
	.fade-enter-active,
	.fade-appear-active {
		transition: opacity 3s ease;
	}
</style>
